import React, { createContext, useContext, useMemo, type ReactNode } from "react";
import { useMediaQuery } from "../hooks/useMediaQuery";
import { RESPONSIVE_QUERIES } from "./breakpoints";

export type ResponsiveState = {
  isNarrow: boolean;
  isMobile: boolean;
  isCompact: boolean;
  isDesktop: boolean;
};

const ResponsiveContext = createContext<ResponsiveState | null>(null);

export const ResponsiveProvider = ({ children }: { children: ReactNode }) => {
  const isNarrow = useMediaQuery(RESPONSIVE_QUERIES.narrow);
  const isMobile = useMediaQuery(RESPONSIVE_QUERIES.mobile);
  const isCompact = useMediaQuery(RESPONSIVE_QUERIES.compact);
  const value = useMemo(() => ({ isNarrow, isMobile, isCompact, isDesktop: !isCompact }), [isCompact, isMobile, isNarrow]);
  return <ResponsiveContext.Provider value={value}>{children}</ResponsiveContext.Provider>;
};

export const useResponsive = (): ResponsiveState => {
  const value = useContext(ResponsiveContext);
  if (!value) throw new Error("useResponsive must be used inside ResponsiveProvider");
  return value;
};

